import {
  ConfigurableField,
  CustomFieldConfigMap,
} from "../../../administration/ticket_creation/types/Config";
import { useSaveConfigManager } from "./useSaveConfigManager";

export function useFieldConfig<T extends ConfigurableField>(
  fieldName: T
): CustomFieldConfigMap[T] | undefined {
  const manager = useSaveConfigManager();
  const config = manager.getFieldConfig<T>(fieldName);
  return config;
}
